(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var DDProduct = DDProduct || {};
    window.DDProduct = DDProduct;

    var images = [];
    var currentIndex = 0;


    // ═══════════════════════════════════════════
    // 留咨弹窗
    // ═══════════════════════════════════════════

    var openBtn = document.getElementById('ddOpenInquiry');
    var modal = document.getElementById('ddInquiryModal');

    if (openBtn && modal) {
      openBtn.addEventListener('click', function() {
        console.log('Product Type Title:', this.dataset.productType);
        // modal.classList.add('is-open');
        // document.body.style.overflow = 'hidden';
      });

      modal.addEventListener('click', function(e) {
        if (e.target === modal) DDProduct.closeInquiry();
      });
    }

    DDProduct.closeInquiry = function() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    };


    // ═══════════════════════════════════════════
    // 移动端滑动画廊指示器
    // ═══════════════════════════════════════════

    var mobileGallery = document.querySelector('.dd-gallery--mobile');
    var dots = document.querySelectorAll('.dd-gallery-dots span');
    if (mobileGallery && dots.length) {
      mobileGallery.addEventListener('scroll', function() {
        var scrollLeft = mobileGallery.scrollLeft;
        var width = mobileGallery.offsetWidth;
        var index = Math.round(scrollLeft / width);
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === index);
        });
      });
    }
  });

})();
